import Link from 'next/link';
import clsx from 'clsx';

import auth from '@config/auth.json';
import useI18n from '@i18n';
import { generateRoute } from '@utils/router';

import ContainerWithLayout from '../Base/ContainerWithLayout';
import RegisterButton from '../Base/RegisterButton';
import SectionTitle from '../Base/SectionTitle';
import HowStartWorkBlock from './HowStartWorkBlock';

import styles from './HowStartWork.module.scss';

import step1Img from './img/step1.svg';
import step2Img from './img/step2.svg';
import step3Img from './img/step3.svg';
import step4Img from './img/step4.svg';

interface IHowStartWorkProps {
    handleRegistration: () => void;
    widgetIsLoading: boolean;
    isAuth: boolean;
}

const HowStartWork: React.FC<IHowStartWorkProps> = ({
    handleRegistration,
    widgetIsLoading,
    isAuth,
}) => {
    const { t, locale } = useI18n('Landing');
    const signUpLink = generateRoute(auth.REG_URL, { locale });

    return (
        <section className={styles.howStartWork}>
            <ContainerWithLayout colorName="grey">
                <div className={clsx(styles.landingContainer, styles.howStartWork_content)}>
                    <div className={styles.howStartWork_header}>
                        <SectionTitle classname={styles.howStartWork_title} bigger>
                            {t('How to get started?')}
                        </SectionTitle>
                        <div className={styles.howStartWork_buttonWrapper}>
                            <RegisterButton
                                handleRegistration={handleRegistration}
                                widgetIsLoading={widgetIsLoading}
                                isAuth={isAuth}
                            />
                        </div>
                    </div>
                    <div className={styles.howStartWork_content_list}>
                        <HowStartWorkBlock
                            imgSrc={step1Img}
                            title={<Link href={signUpLink}>{t('Sign up')}</Link>}
                            text={t('After registering you will get access to 200+ offers')}
                        />
                        <HowStartWorkBlock
                            imgSrc={step2Img}
                            title={<Link href={`/${locale}/offers`}>{t('Choose an offer')}</Link>}
                            text={t(
                                'Connect the platform, site or social network from which you will advertise',
                            )}
                        />
                        <HowStartWorkBlock
                            imgSrc={step3Img}
                            title={
                                <Link
                                    href={`/${locale}/info/traffic-arbitrage/traffic-arbitrage-education/arbitrazh-trafika-chto-ehto-takoe/`}
                                >
                                    {t('Launch traffic')}
                                </Link>
                            }
                            text={t('Drive advertisers traffic that will perform targeted actions')}
                        />
                        <HowStartWorkBlock
                            imgSrc={step4Img}
                            title={
                                <Link href={`/${locale}/info/faq/revshare-chto-eto/`}>
                                    {t('Earn')}
                                </Link>
                            }
                            text={t(
                                'Get rewards for your users actions and withdraw your earnings in any convenient way',
                            )}
                        />
                    </div>
                </div>
            </ContainerWithLayout>
        </section>
    );
};

export default HowStartWork;
